import { getWeekdays } from "@/utils/transformDate";
import { useRouter } from "next/router";
import { useMemo } from "react";

export default function CalendarWeeks() {
	const router = useRouter();

	const weekdays = useMemo(() => {
		return getWeekdays(router.locale || "en");
	}, [router.locale]);

	return (
		<div className="grid grid-flow-row grid-cols-7 gap-2 text-center text-xs font-bold  xs:gap-4">
			{weekdays.map((week) => (
				<span key={week}>{week}</span>
			))}
		</div>
	);
}
